import { Icons } from "./icons"

export function Loader() {
  return (
    <div className="flex items-center justify-center">
      <Icons.loader className="h-5 w-5 animate-spin" />
    </div>
  )
}
